export default __webpack_public_path__ + "8f5022be1f586b79a84f9a26c781d643.png";